import axios from 'axios';
import Cookies from 'js-cookie';
import { safeWindow } from '../safeWindow/safeWindow';

export const ACCESS_TOKEN_COOKIE_NAME = 'accessToken';
export const SALES_SESSION_COOKIE_NAME = 'salesSession';
export const SALES_SESSION_STORAGE_KEY = 'salesSession';
export const SALES_SESSION_HEADER_NAME = 'x-sales-session';
export const AUTH_REFRESH_URL = '/api/auth/v1/refresh';
export const SALES_SESSION_EXPIRED_ERROR_CODE = 'SALES_SESSION_EXPIRED';

const getSessionStorage = (): Storage | undefined => safeWindow()?.sessionStorage;

export const getAgentToken = (): string | undefined => Cookies.get(ACCESS_TOKEN_COOKIE_NAME);

export const hasAgentToken = (): boolean => !!getAgentToken();

export const isSalesSession = (): boolean => {
  if (hasAgentToken()) {
    getSessionStorage()
      ?.setItem(SALES_SESSION_STORAGE_KEY, 'true');

    return true;
  }

  return !!Cookies.get(SALES_SESSION_COOKIE_NAME)
    || getSessionStorage()
      ?.getItem(SALES_SESSION_STORAGE_KEY) === 'true';
};

export const clearSalesSessionMarker = (): void => {
  getSessionStorage()
    ?.removeItem(SALES_SESSION_STORAGE_KEY);
};

let pendingRefresh: Promise<boolean> | undefined;

export const refreshSalesToken = (): Promise<boolean> => {
  if (!pendingRefresh) {
    pendingRefresh = axios.post(AUTH_REFRESH_URL)
      .then(() => true, () => false)
      .finally(() => {
        pendingRefresh = undefined;
      });
  }

  return pendingRefresh;
};
